import { Directive } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

/**
 * {@link https://netbasal.com/forwarding-form-controls-to-custom-control-components-in-angular-701e8406cc55 Source of this directive}
 */
@Directive({
  selector: '[mmNoopValueAccessor]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: NoopValueAccessorDirective,
    },
  ],
})
export class NoopValueAccessorDirective implements ControlValueAccessor {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  registerOnChange(_: never): void {
    // Required by control value accessor
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  registerOnTouched(_: never): void {
    // Required by control value accessor
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  writeValue(_: never): void {
    // Required by control value accessor
  }
}
